import { Component } from '@angular/core';

@Component({
  selector: 'app-login-with-qr-main',
  templateUrl: './login-with-qr-main.component.html',
  styleUrls: ['./login-with-qr-main.component.css']
})
export class LoginWithQrMainComponent {

  english:boolean=true;
  hindi:boolean=false;
  ngOnInit(): void {
    const storeVal = localStorage.getItem('selectedValue');
    if (storeVal == 'english') {
      this.english = true;
      this.hindi = false;
    }
    if (storeVal == 'hindi') {

      this.english = false;
      this.hindi = true;
    }

  }

}
